export default __webpack_public_path__ + "static/media/151-maps-and-flags-3.21b4e7ac.png";